import { ROUTE } from 'common/configuration/constants';
import { hit as hit_jan } from 'common/tracking/jan';
import { sendGA4Event } from 'common/tracking/sendGA4Event';

export type ProfileCardPickerSocialActionType = 'avatar' | 'background';

type CustomizationSlice = {
  mainAvatar?: {
    path?: string | null;
    internalId?: number | string | null;
  } | null;
  mainBanner?: {
    path?: string | null;
    internalId?: number | string | null;
  } | null;
};

export function hadProfileCustomizationForMode(
  mode: 'avatar' | 'background',
  customization: CustomizationSlice | null | undefined
): boolean {
  const current =
    mode === 'avatar' ? customization?.mainAvatar : customization?.mainBanner;
  return Boolean(
    current != null && (current.path != null || current.internalId != null)
  );
}

export function trackProfileCardPickerSave(
  socialActionType: ProfileCardPickerSocialActionType,
  hadExistingCustomization: boolean
): void {
  const social_action_update_type = hadExistingCustomization ? 'edit' : 'add';
  const site_route = ROUTE != null ? String(ROUTE) : '';
  const payload = {
    social_action_type: socialActionType,
    social_action_update_type,
    site_route
  };
  hit_jan('social_action_click', payload);
}

export function trackCoverEditModalImpression(): void {
  const site_route = ROUTE != null ? String(ROUTE) : '';
  const payload = {
    type: 'customize_images',
    site_route
  };
  sendGA4Event('modal_impression', payload);
}
